var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 111,
    viewBox: "0 0 137 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_7991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8743 107.914C92.6934 107.914 112.813 87.7938 112.813 62.9748C112.813 38.1558 92.6934 18.036 67.8743 18.036C43.0553 18.036 22.9355 38.1558 22.9355 62.9748C22.9355 87.7938 43.0553 107.914 67.8743 107.914Z",
    stroke: "#05CB67",
    strokeWidth: 0.72,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.51 1.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8055 104.04C18.6828 95.9176 13.1511 85.569 10.9099 74.3027C8.6687 63.0365 9.81868 51.3586 14.2144 40.746C18.6102 30.1333 26.0543 21.0625 35.6054 14.6806C45.1565 8.29869 56.3855 4.89233 67.8725 4.89233C79.3595 4.89233 90.5886 8.29869 100.14 14.6806C109.691 21.0625 117.135 30.1333 121.531 40.746C125.926 51.3586 127.076 63.0365 124.835 74.3027C122.594 85.569 117.062 95.9176 108.939 104.04",
    stroke: "#05CB67",
    strokeWidth: 0.72,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.51 1.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9373 51.6312C79.2922 51.6181 79.6462 51.6767 79.978 51.8035C80.3098 51.9303 80.6126 52.1227 80.8684 52.3692C81.1242 52.6157 81.3276 52.9112 81.4666 53.2381C81.6055 53.565 81.6772 53.9166 81.6772 54.2718C81.6772 54.627 81.6055 54.9786 81.4666 55.3055C81.3276 55.6324 81.1242 55.9279 80.8684 56.1744C80.6126 56.4209 80.3098 56.6133 79.978 56.7401C79.6462 56.8669 79.2922 56.9255 78.9373 56.9124",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9373 51.6312C79.2922 51.6181 79.6462 51.6767 79.978 51.8035C80.3098 51.9303 80.6126 52.1227 80.8684 52.3692C81.1242 52.6157 81.3276 52.9112 81.4666 53.2381C81.6055 53.565 81.6772 53.9166 81.6772 54.2718C81.6772 54.627 81.6055 54.9786 81.4666 55.3055C81.3276 55.6324 81.1242 55.9279 80.8684 56.1744C80.6126 56.4209 80.3098 56.6133 79.978 56.7401C79.6462 56.8669 79.2922 56.9255 78.9373 56.9124",
    stroke: "#333333",
    strokeWidth: 0.936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9267 51.6312C56.5717 51.6181 56.2178 51.6767 55.886 51.8035C55.5541 51.9303 55.2513 52.1227 54.9955 52.3692C54.7398 52.6157 54.5363 52.9112 54.3974 53.2381C54.2584 53.565 54.1868 53.9166 54.1868 54.2718C54.1868 54.627 54.2584 54.9786 54.3974 55.3055C54.5363 55.6324 54.7398 55.9279 54.9955 56.1744C55.2513 56.4209 55.5541 56.6133 55.886 56.7401C56.2178 56.8669 56.5717 56.9255 56.9267 56.9124",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9267 51.6312C56.5717 51.6181 56.2178 51.6767 55.886 51.8035C55.5541 51.9303 55.2513 52.1227 54.9955 52.3692C54.7398 52.6157 54.5363 52.9112 54.3974 53.2381C54.2584 53.565 54.1868 53.9166 54.1868 54.2718C54.1868 54.627 54.2584 54.9786 54.3974 55.3055C54.5363 55.6324 54.7398 55.9279 54.9955 56.1744C55.2513 56.4209 55.5541 56.6133 55.886 56.7401C56.2178 56.8669 56.5717 56.9255 56.9267 56.9124",
    stroke: "#333333",
    strokeWidth: 0.936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8473 47.592L78.6132 57.8448C78.6132 57.8448 76.2373 67.4712 67.9321 67.4712C59.6269 67.4712 57.2509 57.8448 57.2509 57.8448L57.0168 47.592L63.2449 43.5456L78.8473 47.592Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5467 65.5488C58.5467 65.5488 51.0552 65.5488 47.7792 76.8528C45.108 86.0652 36.2807 91.1088 48.9743 96.5556H86.7744C99.468 91.1088 90.6407 86.0652 87.9695 76.8528C84.6935 65.5488 77.2019 65.5488 77.2019 65.5488C74.6687 67.9372 71.3235 69.2753 67.8419 69.2928C64.3781 69.2828 61.0504 67.9425 58.5467 65.5488Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 0.936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0072 45.4608C67.0428 53.2908 79.8084 50.6808 79.8084 50.6808C79.8084 43.8984 76.1796 38.2824 67.9896 38.2824C59.0904 38.2824 56.1744 43.8984 56.1744 50.6808C56.1744 50.6808 61.8192 48.1896 63.0144 45.4608",
    fill: "#B5BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0072 45.4608C67.0428 53.2908 79.8084 50.6808 79.8084 50.6808C79.8084 43.8984 76.1796 38.2824 67.9896 38.2824C59.0904 38.2824 56.1744 43.8984 56.1744 50.6808C56.1744 50.6808 61.8192 48.1896 63.0144 45.4608",
    stroke: "#333333",
    strokeWidth: 0.936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.666 56.3184C73.346 56.3184 73.8972 55.7672 73.8972 55.0872C73.8972 54.4072 73.346 53.856 72.666 53.856C71.986 53.856 71.4348 54.4072 71.4348 55.0872C71.4348 55.7672 71.986 56.3184 72.666 56.3184Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0071 56.3184C63.6871 56.3184 64.2383 55.7672 64.2383 55.0872C64.2383 54.4072 63.6871 53.856 63.0071 53.856C62.3271 53.856 61.7759 54.4072 61.7759 55.0872C61.7759 55.7672 62.3271 56.3184 63.0071 56.3184Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.504 60.4872C63.504 60.4872 64.584 62.8596 67.896 62.8596H67.7773C71.1001 62.8596 72.1693 60.4872 72.1693 60.4872",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.504 60.4872C63.504 60.4872 64.584 62.8596 67.896 62.8596H67.7773C71.1001 62.8596 72.1693 60.4872 72.1693 60.4872",
    stroke: "#333333",
    strokeWidth: 0.936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8672 55.3752V57.8808",
    stroke: "#333333",
    strokeWidth: 0.936,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1573 73.9332H87.5881C87.9096 73.9332 88.2279 73.9965 88.5249 74.1195C88.8219 74.2426 89.0918 74.4229 89.3191 74.6502C89.5464 74.8775 89.7267 75.1474 89.8498 75.4444C89.9728 75.7414 90.0361 76.0597 90.0361 76.3812V98.28C90.0361 98.6123 89.9041 98.9309 89.6692 99.1659C89.4342 99.4008 89.1156 99.5328 88.7833 99.5328H46.9621C46.6317 99.53 46.3158 99.3967 46.0832 99.1621C45.8506 98.9274 45.7201 98.6104 45.7201 98.28V76.3848C45.7191 75.7368 45.9751 75.1148 46.432 74.6553C46.8889 74.1957 47.5093 73.9361 48.1573 73.9332Z",
    fill: "#EFEFEF",
    stroke: "#333333",
    strokeWidth: 0.936,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4069 99.5004V101.48C90.4073 101.802 90.3444 102.121 90.2215 102.418C90.0987 102.715 89.9183 102.985 89.6909 103.212C89.4635 103.44 89.1935 103.62 88.8963 103.743C88.5991 103.866 88.2805 103.929 87.9589 103.928H47.9053C47.5837 103.929 47.2652 103.866 46.9679 103.743C46.6707 103.62 46.4006 103.44 46.1732 103.212C45.9458 102.985 45.7655 102.715 45.6427 102.418C45.5198 102.121 45.4568 101.802 45.4573 101.48V99.5004H90.4069Z",
    fill: "#EFEFEF",
    stroke: "#333333",
    strokeWidth: 0.936,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.836 103.928H9.31325C7.65706 103.928 6.31445 105.271 6.31445 106.927V106.931C6.31445 108.587 7.65706 109.93 9.31325 109.93H122.836C124.492 109.93 125.834 108.587 125.834 106.931V106.927C125.834 105.271 124.492 103.928 122.836 103.928Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4571 39.2256C46.479 39.2256 47.3075 38.3972 47.3075 37.3752C47.3075 36.3533 46.479 35.5248 45.4571 35.5248C44.4351 35.5248 43.6067 36.3533 43.6067 37.3752C43.6067 38.3972 44.4351 39.2256 45.4571 39.2256Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4525 3.7008C94.4744 3.7008 95.3029 2.87235 95.3029 1.8504C95.3029 0.828452 94.4744 0 93.4525 0C92.4305 0 91.6021 0.828452 91.6021 1.8504C91.6021 2.87235 92.4305 3.7008 93.4525 3.7008Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.834 78.588C129.344 78.588 132.188 75.7432 132.188 72.234C132.188 68.7248 129.344 65.88 125.834 65.88C122.325 65.88 119.48 68.7248 119.48 72.234C119.48 75.7432 122.325 78.588 125.834 78.588Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.088 92.178C32.5972 92.178 35.442 89.3332 35.442 85.824C35.442 82.3148 32.5972 79.47 29.088 79.47C25.5788 79.47 22.734 82.3148 22.734 85.824C22.734 89.3332 25.5788 92.178 29.088 92.178Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9135 72.9036C100.635 72.9036 102.031 71.5078 102.031 69.786C102.031 68.0642 100.635 66.6684 98.9135 66.6684C97.1917 66.6684 95.7959 68.0642 95.7959 69.786C95.7959 71.5078 97.1917 72.9036 98.9135 72.9036Z",
    stroke: "#05CB67",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.088 3.72238V9.07198",
    stroke: "#05CB67",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7627 6.39722H26.4131",
    stroke: "#05CB67",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2456 68.6124C29.5844 68.6124 37.9656 60.2312 37.9656 49.8924C37.9656 39.5536 29.5844 31.1724 19.2456 31.1724C8.90686 31.1724 0.525635 39.5536 0.525635 49.8924C0.525635 60.2312 8.90686 68.6124 19.2456 68.6124Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.0548,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2456 64.7712C27.463 64.7712 34.1244 58.1097 34.1244 49.8924C34.1244 41.6751 27.463 35.0136 19.2456 35.0136C11.0283 35.0136 4.36682 41.6751 4.36682 49.8924C4.36682 58.1097 11.0283 64.7712 19.2456 64.7712Z",
    fill: "url(#paint0_linear_719_7991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.056 35.6499L117.265 39.4403L119.798 41.9732L123.589 38.1828L121.056 35.6499Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.03 42.7424L124.358 37.4145L134.54 47.5968C135.247 48.3037 135.644 49.2624 135.644 50.262C135.644 51.2617 135.247 52.2204 134.54 52.9273C133.834 53.6341 132.875 54.0312 131.875 54.0312C130.876 54.0312 129.917 53.6341 129.21 52.9273L119.028 42.7449L119.03 42.7424Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M113.166 35.37L119.801 41.976C112.601 47.2032 102.676 47.2824 95.2705 39.8772C89.4601 34.0704 89.1109 28.1376 90.6697 21.3084L91.5085 21.2868H122.285",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.526 43.3188C117.59 43.3188 124.938 35.9707 124.938 26.9064C124.938 17.8421 117.59 10.494 108.526 10.494C99.4612 10.494 92.1132 17.8421 92.1132 26.9064C92.1132 35.9707 99.4612 43.3188 108.526 43.3188Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.526 39.6756C115.578 39.6756 121.295 33.9586 121.295 26.9064C121.295 19.8542 115.578 14.1372 108.526 14.1372C101.473 14.1372 95.7563 19.8542 95.7563 26.9064C95.7563 33.9586 101.473 39.6756 108.526 39.6756Z",
    fill: "url(#paint1_linear_719_7991)",
    stroke: "#333333",
    strokeWidth: 1.08,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.79 40.3905L122.007 45.1736L128.182 51.3492L132.965 46.566L126.79 40.3905Z",
    fill: "url(#paint2_linear_719_7991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.24 52.1424C13.2162 52.1424 14.0076 51.351 14.0076 50.3748C14.0076 49.3986 13.2162 48.6072 12.24 48.6072C11.2638 48.6072 10.4724 49.3986 10.4724 50.3748C10.4724 51.351 11.2638 52.1424 12.24 52.1424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5696 52.1424C20.5458 52.1424 21.3372 51.351 21.3372 50.3748C21.3372 49.3986 20.5458 48.6072 19.5696 48.6072C18.5934 48.6072 17.802 49.3986 17.802 50.3748C17.802 51.351 18.5934 52.1424 19.5696 52.1424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9027 52.1424C27.879 52.1424 28.6703 51.351 28.6703 50.3748C28.6703 49.3986 27.879 48.6072 26.9027 48.6072C25.9265 48.6072 25.1351 49.3986 25.1351 50.3748C25.1351 51.351 25.9265 52.1424 26.9027 52.1424Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_7991",
    x1: 4.36682,
    y1: 49.8924,
    x2: 34.1244,
    y2: 49.8924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_719_7991",
    x1: 99.4942,
    y1: 35.9385,
    x2: 117.553,
    y2: 17.8801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_719_7991",
    x1: 10584.4,
    y1: -12286.1,
    x2: 10674.3,
    y2: -12375.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_7991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136.192,
    height: 110.47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2);
export default __webpack_public_path__ + "static/media/search2.c551c86cb4c52db0f129f14806cb029b.svg";
export { ForwardRef as ReactComponent };